<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 7.33463C11.7801 7.33463 15.3334 8.2213 15.3334 10.0013V11.3346H4.66672V10.0013C4.66672 8.2213 8.22006 7.33463 10.0001 7.33463ZM10.0001 6.0013C9.29281 6.0013 8.61453 5.72035 8.11444 5.22025C7.61434 4.72016 7.33339 4.04188 7.33339 3.33464C7.33339 2.62739 7.61434 1.94911 8.11444 1.44902C8.61453 0.94892 9.29281 0.667969 10.0001 0.667969C10.7073 0.667969 11.3856 0.94892 11.8857 1.44902C12.3858 1.94911 12.6667 2.62739 12.6667 3.33464C12.6667 4.04188 12.3858 4.72016 11.8857 5.22025C11.3856 5.72035 10.7073 6.0013 10.0001 6.0013ZM3.33339 4.39464L4.74672 2.97464L5.69339 3.9213L4.27339 5.33464L5.69339 6.74797L4.74672 7.69463L3.33339 6.27463L1.92006 7.69463L0.973389 6.74797L2.39339 5.33464L0.973389 3.9213L1.92006 2.97464L3.33339 4.39464Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#DA1E28'
    },
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '12'
    }
  }
}
</script>
